angular.
module("dx.webapp.student").
controller("DxCreateStudentController", function DxCreateStudentController(
	$interval,
	$scope,

	dxApi,
	validationService,
	DX_URLS,
	DX_JOB_STATUS,

	dxLocalize
) {
	"use strict";

	var self = this;
	var jobInterval = null;

	self.job = null;
	self.jobLink = "";
	self.isCreatingStudent = false;
	self.isJobDone = false;
	self.isHandlingSubmit = false;
	self.creationInfo = "";
	self.errors = [];

	self.$onInit = function onInit() {
		self.emptyStudentData = Object.freeze({
			firstName: "",
			lastName: "",
			email: "",
			studentCode: "",
			accessibilitySettings: {
				textToSpeech: false,
				audioFiles: false,
				extendedTime: false,
				spellcheck: false,
				immersiveReader: false,
			},
		});
		self.studentData = angular.copy(self.emptyStudentData);
	};

	self.onFormSubmit = function onFormSubmit() {
		validateInput();
		if (self.errors.length === 0) {
			createStudent();
		}
	};

	function validateInput() {
		self.errors = [];

		if (!validationService.isEmailValid(self.studentData.email, true)) {
			self.errors.push("CreateStudent.Error.InvalidEmail");
		}
		if (!validationService.isNameValid(self.studentData.firstName)) {
			self.errors.push("CreateStudent.Error.InvalidFirstName");
		}
		if (!validationService.isNameValid(self.studentData.lastName)) {
			self.errors.push("CreateStudent.Error.InvalidLastName");
		}
		if (!self.isStudentCodesDisabled && !validationService.isStudentCodeValid(self.studentData.studentCode)) {
			self.errors.push("CreateStudent.Error.InvalidStudentCode");
		}
	}

	function createStudent() {
		self.isJobDone = false;
		self.isHandlingSubmit = true;
		var data = {
			organizationId: self.organizationId,
			students: [self.studentData],
		};

		dxApi.v1.students.create(data).then(function success(response) {
			self.studentData = angular.copy(self.emptyStudentData);
			self.job = response.data;
			showStudentCreateSuccessMsg();
		}, function reject(resp) {
			self.isHandlingSubmit = false;
			if (resp.status === 409) {
				self.errors.push("CreateStudent.Error.AlreadyExists");
				return;
			}
			self.errors.push("CreateStudent.Error.UnexpectedError");
		});
	}

	function showStudentCreateSuccessMsg() {
		self.isCreatingStudent = true;

		jobInterval = $interval(function checkJob() {
			dxApi.v1.jobs.get(self.job.id).then(function success(response) {
				self.job = response.data;
				if (self.job.status === DX_JOB_STATUS.DONE) {
					$interval.cancel(jobInterval);
					self.isCreatingStudent = false;
					self.isJobDone = true;
					self.isHandlingSubmit = false;
					self.jobLink = DX_URLS.get("jobsView", {jobId: self.job.id});

					self.creationInfo = self.job.taskCountSkipped === 0 ? dxLocalize.get("CreateStudent.CreateSuccess") :
						dxLocalize.get("CreateStudent.CreateError");
				}
			}, function fail() {
				$interval.cancel(jobInterval);
				self.isCreatingStudent = false;
				self.isHandlingSubmit = false;
				self.errors.push("CreateStudent.Error.UnexpectedError");
			});
		}, 1000);
	}

	$scope.$on("$destroy", function destroy() {
		$interval.cancel(jobInterval);
	});
});
